import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function canvasFormRelatedTasksReducer(state = initialState.canvasFormRelatedTasks, action) {
	switch (action.type) {
		case types.GET_CANVASFORM_RELATED_TASKS: {
			let {allTasks, ...newState} = state;
			newState.allTasks = formatTasksFromResponse(action.response);
			return newState;
		}
		case types.ADD_CANVASFORM_RELATED_TASK: {
			let index = state.allTasks.list.findIndex((task) => task.id === action.id);
			if (index !== -1) {
				return {
					...state,
					selectedTasks: state.selectedTasks.concat({
						id: action.id,
						name: state.allTasks.list[index].name
					})
				};
			}

			return state;
		}
		case types.REMOVE_CANVASFORM_RELATED_TASK: {
			return {
				...state,
				selectedTasks: state.selectedTasks.filter((item) => item.id !== action.id)
			};
		}
		case types.SET_DEFAULT_TASK_SELECTION: {
			let {selectedTasks, ...newState} = state;
			let tasks = [...selectedTasks];

			_.forEach(action.taskList, (item) => {
				let existingItem = _.filter(tasks, (task) => {
					if (task.id === item.id) {
						return task;
					}
				});
				if (item.id && item.name && existingItem.length <= 0) {
					tasks.push(item);
				}
			});
			newState.selectedTasks = tasks;
			return newState;
		}
		case types.RESET_TASK_SELECTION: {
			let {selectedTasks, ...newState} = state;
			newState.selectedTasks = [];
			return newState;
		}
		case types.CLOSE_CANVAS_FORM_COMBINED: {
			let {selectedTasks, ...newState} = state;
			newState.selectedTasks = [];
			return newState;
		}
		default:
			return state;
	}
}

function formatTasksFromResponse(response) {
	let canvasFormTask = {totalCount: response.totalCount};
	canvasFormTask.availablePages = response.availablePages;

	if (response.taskGroups && response.taskGroups.length > 0) {
		canvasFormTask.currentPage = response.taskGroups[0].currentPage;
		canvasFormTask.list = response.taskGroups[0].tasks;
	} else {
		canvasFormTask.currentPage = 0;
		canvasFormTask.availablePages = 0;
		canvasFormTask.list = [];
	}
	return canvasFormTask;
}
